export const USER_ACTIVITY_TYPE_OPTIONS = [
  { labelKey: "All", value: "" },
  { labelKey: "Category", value: "category" },
  { labelKey: "Item", value: "item" },
  { labelKey: "Modifier Group", value: "modifierGroup" },
  { labelKey: "Modifier Customization", value: "modifierCustomization" },
  { labelKey: "Item Group", value: "itemGroup" },
  { labelKey: "Menu Setup", value: "menuSetup" },
  { labelKey: "Menu", value: "menu" },
  { labelKey: "Item Tag", value: "itemTag" },
  { labelKey: "Ingredient", value: "ingredient" },
  { labelKey: "Allergen", value: "allergen" },
  { labelKey: "Branch", value: "branch" },
  { labelKey: "Zone", value: "zone" },
  { labelKey: "Region", value: "region" },
  { labelKey: "City", value: "city" },
  { labelKey: "Country", value: "country" },
  { labelKey: "Role", value: "role" },
  { labelKey: "User", value: "user" },
  { labelKey: "Customer", value: "customer" },
  { labelKey: "Coupon", value: "coupon" },
  { labelKey: "Coupon Group", value: "couponGroup" },
  { labelKey: "Promotion", value: "promotion" },
  { labelKey: "Coupon Redeem", value: "couponRedeem" },
  // { labelKey: "Card Type", value: "cardType" },
  // { labelKey: "Card Template", value: "cardTemplate" },
  // { labelKey: "Booking", value: "booking" },
  // { labelKey: "Campaign", value: "campaign" },
  { labelKey: "Push Notification", value: "pushNotification" },
  { labelKey: "Banner", value: "banner" },
  { labelKey: "Offer Banner", value: "offerBanner" },
  // { labelKey: "Vehicle", value: "vehicle" },
  { labelKey: "Brand", value: "brand" },
  { labelKey: "Delivery Partner", value: "deliveryPartner" },
  { labelKey: "Support Issue Type", value: "supportIssueType" },
  { labelKey: "Ticket", value: "ticket" },
  { labelKey: "System Settings", value: "systemSettings" },
  { labelKey: "Loyalty Points", value: "loyalty-points" },
]

export const getUserActivityTypeLabel = (type, t) => {
  const option = USER_ACTIVITY_TYPE_OPTIONS.find(item => item.value === type)
  return option ? t(option.labelKey) : type
}

export default USER_ACTIVITY_TYPE_OPTIONS
